import React, { Children, ReactNode } from "react";
import { Checkbox, Box } from "@mui/material";
import { BoxProp } from "./BoxProps";

const Boxldn = (props: BoxProp) => {
  return <Box {...props} />;
};

export default Boxldn;
